import { CmsPublicationListVendor } from '../../../../components/Cms';

export function CmsPublications() {
  return <CmsPublicationListVendor />;
}
